import {s} from './scripting.js';
import {lazy} from './lazy.js';
import {rewind} from './time.js';
import {getArgs} from './args.js';

export const loop = (triggers) => {
    let historyStart = undefined;
    let x=0;
    return (...args) => {
        let {coords, stepNumber, history} = getArgs(args);
        if (historyStart === undefined) {
            // record the first step of loop
            historyStart = history.length - 1;
        }
        // figure out how many triggers occur in steps
        let start = historyStart - lazy(triggers, ...args);
        if (start < 0) {
            historyStart = undefined;
            return coords;
        }
        let sliced = history.slice(start, historyStart);
            
        return sliced[(++x)%sliced.length];
    };
};
 
